
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';

const Layout = () => {
  const { user } = useAuth();

  const isAdminOrTeacherOrStudent = user && ['admin', 'teacher', 'student'].includes(user.role);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      
      <div className="flex flex-1">
        {isAdminOrTeacherOrStudent && <Sidebar />}
        
        <main className={`flex-1 ${isAdminOrTeacherOrStudent ? 'ml-64' : ''}`}>
          <div className="container mx-auto px-4 py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;